export default __webpack_public_path__ + "static/meet_our_jedi-d24a7475ea1166d1c1c7fa1c1fde6072.png";